import PropTypes from 'prop-types';

import { Copyright } from '../../Copyright';
import { ContactsBFACM } from './Contacts';
import { FooterStyled } from './FooterBFACM.styles';

export const FooterBFACM = ({ id, className }) => (
  <>
    <FooterStyled id={id ?? 'footer'} className={className ?? null}>
      <ContactsBFACM />
    </FooterStyled>

    <Copyright />
  </>
);

FooterBFACM.propTypes = {
  className: PropTypes.string,
  id: PropTypes.string,
};
